import { createSlice } from "@reduxjs/toolkit";

const verifyMantraSlice = createSlice({
  name: "verifyMantra",
  initialState: {
    isVerifyOpen: false,
  },
  reducers: {
    toogleVerify: (state) => {
      state.isVerifyOpen = !state.isVerifyOpen;
    },
  },
});

export const { toogleVerify } = verifyMantraSlice.actions;
export default verifyMantraSlice.reducer;